import { TEAM_MEMBERS } from 'utils/reducers';

const initialState = {
    show: false,
};

const showTeamMembersReducer = (state = initialState, action) => {
    switch (action.type) {
        case TEAM_MEMBERS.display:
            return { ...state, show: true };
        case TEAM_MEMBERS.hide:
            return { ...state, show: false };
        default:
            return state;
    }
};

export default showTeamMembersReducer;
